import { useWeb3React } from "@web3-react/core";
import { useEffect, useState } from "react";
import { RibbonCoveredCallFactory } from "../codegen/RibbonCoveredCallFactory";
import { VaultAddressMap } from "../constants/constants";
import { useWeb3Context } from "./web3Context";
export var getVault = function (library, vaultOption, useSigner) {
    if (useSigner === void 0) { useSigner = true; }
    if (!VaultAddressMap[vaultOption].v1) {
        return null;
    }
    var provider = useSigner ? library.getSigner() : library;
    var vault = RibbonCoveredCallFactory.connect(VaultAddressMap[vaultOption].v1, provider);
    return vault;
};
var useVault = function (vaultOption) {
    var _a = useWeb3React(), library = _a.library, active = _a.active;
    var provider = useWeb3Context().provider;
    var _b = useState(null), vault = _b[0], setVault = _b[1];
    useEffect(function () {
        var vault = getVault(library || provider, vaultOption, active);
        setVault(vault);
    }, [active, library, provider, vaultOption]);
    return vault;
};
export default useVault;
//# sourceMappingURL=useVault.js.map